import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import { SectionHeading } from '../../Styles/style'
import SectionWrapper from '../../Components/SectionWrapper'
import weddingImgOne from '../../../assets/wedding-proof-1.png'
import weddingImgTwo from '../../../assets/wedding-proof-2.png'
import styled from '@emotion/styled'

const Image = styled.img`
    width: calc( 60% - 15px );
    height: auto;

    &.img2{
        width:  calc( 40% - 15px );
    }

    @media(max-width: 600px){
        width: 100%;
        &.img2{
            width: 100%;
        }
    }
`
const ImageBox = styled(Box)`
    display: flex;
    justify-content: space-between;
    @media(max-width: 600px){
        display: block;
    }
`

const About = () => {
  return (
    <SectionWrapper>
        <Grid xs={12}>
            <SectionHeading variant="h1">Wedding Proof</SectionHeading>
            <ImageBox>
                <Image src={weddingImgOne} alt="wedding-proof-image"/>
                <Image src={weddingImgTwo} className='img2' alt="wedding-proof-image"/>
            </ImageBox>
        </Grid>
    </SectionWrapper>
  )
}

export default About